import { Grid, VStack } from '@hover/blueprint';
import React from 'react';

import { MobileHeader } from 'src/modules/homeownerApp/components/MobileHeader';
import { sortProjects } from 'src/modules/homeownerApp/components/Utils';
import { useHomeownerAppContext } from 'src/modules/homeownerApp/hooks';
import type { Project } from 'src/shared/graphql/generated';
import { useGetProjectsQuery } from 'src/shared/graphql/generated';
import {
  TranslationNamespace,
  useReactNativeWebView,
  useTranslate,
} from 'src/shared/hooks';
import { WebViewScope } from 'src/shared/hooks/useReactNativeWebView';

import { getMostRecentAddable } from '../../Utils';
import { ProjectCard } from '../Card/ProjectCard';
import { ProjectCardSkeleton } from '../Card/ProjectCardSkeleton';
import { inferProjectAreasFromSpaceTypes } from '../Project';

import { EmptyProjectsList } from './EmptyProjectsList';

const ProjectsList = () => {
  const t = useTranslate(TranslationNamespace.HOMEOWNER_APP);
  const { loggedIn, user } = useHomeownerAppContext();
  // This query is quite slow and is a bottle neck for the initial load of the page
  // We should probably refactor this query not use the Project fragment and
  // only fetch the data we need
  const { data, loading } = useGetProjectsQuery({
    ssr: false,
    fetchPolicy: 'cache-and-network',
  });
  const projects = sortProjects((data?.projects || []) as Project[]);
  const [isWebView] = useReactNativeWebView(WebViewScope.MOBILE_HOMEOWNER);
  const showProfileIcon = !isWebView;

  if (!loggedIn) return <EmptyProjectsList />;
  if (!projects?.length && !loading) return <EmptyProjectsList loggedIn />;

  return (
    <VStack pt={{ tablet: 800 }} px={{ base: 500, tablet: 800 }}>
      <MobileHeader
        headingText={t('projects.projects')}
        isLoading={loading}
        mx={0}
        pb={0}
        px={0}
        showHeaderText
        showProfileIcon={showProfileIcon}
        showSubHeading
        subHeadingText={t('projects.numProjects', {
          count: projects?.length || 0,
        })}
        width="100%"
      />
      <Grid
        gap="500"
        gridAutoFlow="dense"
        gridTemplateColumns={{
          base: 'auto',
          tablet: 'repeat(3, 1fr)',
        }}
        paddingBottom={{ base: 900, tablet: 1000 }}
        pt={{ base: 200 }}
        width="100%"
      >
        {!loading && projects?.length ? (
          projects.map(({ createdAt, name, id, addables, publicOrgInfo }) => {
            const coverImage = getMostRecentAddable(addables);
            const spaceTypes = inferProjectAreasFromSpaceTypes(addables);

            return (
              <ProjectCard
                createdAt={createdAt}
                imagePath={coverImage?.aiGeneratedImage.generatedImagePath}
                key={id}
                projectId={id}
                publicOrgInfo={publicOrgInfo}
                showOrgBranding={!!user?.isHomeowner}
                spaceType={spaceTypes.join(', ')}
                title={name}
              />
            );
          })
        ) : (
          <ProjectCardSkeleton />
        )}
      </Grid>
    </VStack>
  );
};

export { ProjectsList };
